import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createBlock as _createBlock, createElementVNode as _createElementVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-354655ce"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "layout-downloads" }
const _hoisted_2 = { class: "layout-downloads__content" }
const _hoisted_3 = ["innerHTML"]

import DownloadLink from "@/components/UI/DownloadLink.vue";

interface Props {
	title: string;
	downloads: {
		url: string;
		title: string;
		filetype: string;
		filesize: string;
	}[];
}

export default /*#__PURE__*/_defineComponent({
  __name: 'ContentDownloads',
  props: {
    title: {},
    downloads: {}
  },
  setup(__props: any) {




return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      (_ctx.title)
        ? (_openBlock(), _createElementBlock("h2", {
            key: 0,
            innerHTML: _ctx.title,
            class: "layout-downloads__title"
          }, null, 8, _hoisted_3))
        : _createCommentVNode("", true),
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.downloads, (item, key) => {
        return (_openBlock(), _createBlock(DownloadLink, {
          key: key,
          download: item
        }, null, 8, ["download"]))
      }), 128))
    ])
  ]))
}
}

})